export function Divider() {
  return (
    <div className="w-full px-0 py-[8px]">
      <div className="h-px w-full bg-(--sidebar-divider-color)" />
    </div>
  )
}
